import React from "react";
import "./ProductHeroSection.css";
import Shape from "../Shape/Shape";
import shape2 from "../../assets/shape2.svg";
import shape3 from "../../assets/shape3.svg";

const ProductHeroSection = () => {
  return (
    <section className="product-hero-section">
      <div className="product-hero-content">
        <h1 className="product-hero-title">Our Products</h1>
        <p className="product-hero-tagline">
          We are top-notch candy toy producers.
        </p>
      </div>
      <div className="product-hero-animation"></div>
      <Shape svgPath={shape2} className="product-hero-shape2" />
      <Shape svgPath={shape3} className="product-hero-shape3" />
    </section>
  );
};

export default ProductHeroSection;
